export default "__VITE_ASSET__0y0UHOi9__"